module.exports = __webpack_public_path__ + "img/spoken_detail_80.c5ff97a5.svg";